import React from 'react';

import style from './index.module.scss';

const CommonLabel = ({ value, className, hasError = false }) => {
  return (
    <div
      className={`${style.lableStyle} ${hasError ? style.errorLabel : ''} ${className || ''}`}
      style={hasError ? { color: '#f54646' } : undefined}
    >
      {value}
    </div>
  );
};

export default CommonLabel;
